import { render, staticRenderFns } from "./SamplesTable.vue?vue&type=template&id=29cf088c&scoped=true&"
import script from "./SamplesTable.vue?vue&type=script&lang=js&"
export * from "./SamplesTable.vue?vue&type=script&lang=js&"
import style0 from "./SamplesTable.vue?vue&type=style&index=0&id=29cf088c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cf088c",
  null
  
)

export default component.exports